import React, { Fragment } from 'react';
import {
    BulkDeleteButton,
    BooleanField,
    BooleanInput,
    Create,
    ChipField,
    Datagrid,
    DateField,
    DeleteButton,
    Edit,
    EditButton,
    List,
    ListButton,
    maxLength,
    minLength,
    RefreshButton,
    ReferenceArrayField,
    required,
    SaveButton,
    SelectArrayInput,
    SimpleForm,
    SingleFieldList,
    ReferenceArrayInput,
    TextField,
    TextInput,
    Toolbar,
    TopToolbar,
    usePermissions,
} from 'react-admin'
import { makeStyles } from '@mui/styles';
import EnableButton from '../Button/EnableButton';
import DisableButton from '../Button/DisableButton';

const createDefaultValues = {
    enabled: false,
};

const useStyles = makeStyles({
    toolbar: {
        display: 'flex',
        justifyContent: 'space-between',
    },
});

const validateRequired = [required()];
const validatePartnerName = [required(), minLength(3), maxLength(64)];

const PostEditActions = ({ basePath }) => (
    <TopToolbar>
        <ListButton basePath={basePath} />
        <RefreshButton />
    </TopToolbar>
);

const CustomToolbar = props => (
    <Toolbar {...props} classes={useStyles()}>
        <SaveButton />
    </Toolbar>
);

const CodeBulkActionButtons = props => (
    <Fragment>
        <EnableButton label="Enable" {...props} />
        <DisableButton label="Disable" {...props} />
        <BulkDeleteButton {...props}/>
    </Fragment>
);

export const CustomDeleteButton = props => (
    <DeleteButton {...props} mutationMode="pessimistic" />
  );

export const PartnerList = props => {
    const { permissions } = usePermissions();
    return (
        <List {...props} bulkActionButtons={<CodeBulkActionButtons />}>
            <Datagrid rowClick="edit">
                <TextField label="Partner id" source="id" />
                <ReferenceArrayField label="Channels" reference="Channel" source="channels">
                    <SingleFieldList>
                        <ChipField source="name" />
                    </SingleFieldList>
                </ReferenceArrayField>
                <TextField label="Name" source="name" />
                <DateField label="Date Created" source="dateCreated" showTime />
                <DateField label="Date Modified" source="dateModified" showTime />
                <BooleanField label="Enabled" source="enabled" />
                {permissions === "ADMIN" && <EditButton />}
            </Datagrid>
        </List>
    );
};


export const PartnerEdit = props => (
    <Edit actions={<PostEditActions />} {...props}>
        <SimpleForm toolbar={<CustomToolbar />}>
            <ReferenceArrayInput
                label="Channels"
                source="channels"
                reference="Channel">
                <SelectArrayInput optionText="name" validate={validateRequired} />
            </ReferenceArrayInput>
            <TextInput
                label="Partner Name"
                source="name"
                validate={validatePartnerName}
            />
            <BooleanInput label="Enabled" source="enabled" />
        </SimpleForm>
    </Edit>
);

export const PartnerCreate = props => (
    <Create actions={<PostEditActions />} {...props}>
        <SimpleForm initialValues={createDefaultValues} redirect="list">
            <ReferenceArrayInput
                label="Channels"
                source="channels"
                reference="Channel">
                <SelectArrayInput optionText="name" validate={validateRequired} />
            </ReferenceArrayInput>
            <TextInput
                label="Partner Name"
                source="name"
                validate={validatePartnerName}
            />
            <BooleanInput label="Enabled" source="enabled" />
        </SimpleForm>
    </Create>
);